const FISCAL_REGIME_CODES = {
    0: '0',
    606: '606',
    626: '626'
};
export default FISCAL_REGIME_CODES;
